import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';
import { SubjectService } from 'app/service/subject.service';

@Directive({
  selector: '[authorize]'
})
export class FunctionPermissionDirective {

  constructor(private elementRef: ElementRef,
    private subjectService: SubjectService,
    private render: Renderer2) {

  }

  @Input() set authorize(permissionName: string) {
    this.setAuthorize(permissionName);
    this.subjectService.getUserPermissionsSubject().subscribe(res => {
      this.setAuthorize(permissionName);
    })
  }

  setAuthorize(permissionName){
    var permissionData = JSON.parse(localStorage.getItem("permissions")) as string[];
    if (permissionData && permissionData.findIndex(p => p == permissionName) >= 0) {
      this.render.removeClass(this.elementRef.nativeElement, "permission-hide");
    } else {
       this.render.addClass(this.elementRef.nativeElement, "permission-hide");
    }
  }
}
